import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elRoundimage from './images/MintButtom_elRoundimage_718961.png';
import firebase from 'firebase';
import firestore from 'firebase/firestore';

export default class ButtonEnterheader extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  onClick_elRoundimage = async () => {
    window.open('https://themnemosyne.xyz/metaverse/index.html', '_blank');
  
    firebase.analytics().logEvent(this.context.appActions.dataSheets['localizationSheet'].expandSlotTemplateString("undefined", this.context.appActions.dataSlots));
  }
  
  
  render() {
    const style_elRoundimage = {
      backgroundImage: 'url('+img_elRoundimage+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_elButton = {
      display: 'block',
      fontSize: 30.0,
      color: '(null)',
      textAlign: 'center',
      backgroundColor: 'transparent',
     };
    
    return (
      <div className="ButtonEnterheader">
        <div className="layoutFlow">
          <div className="elRoundimage">
            <div style={style_elRoundimage} onClick={this.onClick_elRoundimage}  />
          </div>
          
          <div className="flowRow flowRow_ButtonEnterheader_elButton_74151">
          <div className="elButton">
            <button className="font-caesarDressingRegular" style={style_elButton}>
              {this.context.locStrings.component2_button_74151}
            </button>
          </div>
          
          </div>
        </div>
        
      </div>
    )
  }
  
}
